import React, { useContext, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FaCode, FaCoffee, FaInfoCircle } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import { HiTerminal } from "react-icons/hi";
import { IoClose, IoVideocam, IoVolumeMedium } from "react-icons/io5";
import { MdKeyboardAlt, MdOutlineDesktopWindows } from "react-icons/md";
import { VscEditorLayout } from "react-icons/vsc";
import github from "../../assets/images/github.png";
import Spacer from "../../components/Utils/Spacer";
import { Context } from "../../context";
import Modal from "./Modal";
import { Terminal } from "./Terminal";
import classes from "./Terminal.module.css";
import useCommands from "./useCommands";
import { useTerminal } from "./useTerminal";

const TerminalContainer = () => {
  const { terminal, setTerminal, lang, viewMode, setViewMode } =
    useContext(Context);
  const [commandsHistory, setCommandsHistory] = useState([]);
  const [isEditModal, setEditModal] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [modalData, setModalData] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const {
    history,
    pushToHistory,
    setHistory,
    setTerminalRef,
    openTerminal,
    setOpenTerminal,
    openLogin,
    setOpenLogin,
    username,
    setUsername,
  } = useTerminal();

  const openModalWithData = (data, title, edit) => {
    setIsOpenModal(true);
    setEditModal(edit);
    setModalData(data);
    setModalTitle(title);
  };

  const closeModal = () => {
    setIsOpenModal(false);
    setModalData("");
  };

  const commands = useCommands(
    pushToHistory,
    setHistory,
    setOpenTerminal,
    commandsHistory,
    openModalWithData,
    closeModal
  );

  const openMenu = () => {
    setIsOpen(true);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <>
      {terminal && (
        <div
          className={
            viewMode === "terminal2d"
              ? classes.terminalExt
              : classes.terminalSection
          }
        >
          <div
            className={`${classes.terminalHeaderMobileButton}`}
            onClick={openMenu}
          >
            <GiHamburgerMenu
              className={`${classes.terminalHeaderMobileHamburger}`}
            />
          </div>

          <div
            className={`${classes.terminalHeaderMobileButton} ${classes.terminalHeaderMobileClose}`}
            onClick={() => setTerminal(false)}
          >
            <span className={classes.terminalHeaderMobileCloseIcon}>
              &times;
            </span>
          </div>

          <div
            className={`${classes.terminalHeaderMobileMenu} ${
              isOpen ? classes.open : ""
            }`}
          >
            <div
              className={`${classes.terminalHeaderMobileHeader}`}
              onClick={closeMenu}
            >
              <span className={classes.modalClose}>&times;</span>
              <span>Close</span>
            </div>

            <div className={classes.terminalHeaderMobileMenuContainer}>
              <div className={classes.terminalHeaderMobileMenuRow}>
                <div className={classes.menuItemInt}>
                  <HiTerminal className={classes.menuIcon} />
                  Terminal
                </div>

                <div className={classes.terminalHeaderMobileButtons}>
                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton2D
                    } ${
                      viewMode === "terminal2d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => {
                      setViewMode("terminal2d");
                      closeMenu();
                    }}
                  >
                    <span>2D</span>
                  </div>

                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton3D
                    } ${
                      viewMode === "terminal3d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => {
                      setViewMode("terminal3d");
                      closeMenu();
                    }}
                  >
                    <span>3D</span>
                  </div>
                </div>
              </div>

              <div className={classes.terminalHeaderMobileMenuRow}>
                <div className={classes.menuItemInt}>
                  <MdOutlineDesktopWindows
                    className={classes.menuIcon}
                    style={{ fontSize: "16px" }}
                  />
                  Os interface
                </div>
                <div className={classes.terminalHeaderMobileButtons}>
                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton2D
                    } ${
                      viewMode === "os2d" ? classes.terminalButtonSelected : ""
                    }`}
                    onClick={() => {
                      setViewMode("os2d");
                      closeMenu();
                    }}
                  >
                    <span>2D</span>
                  </div>

                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton3D
                    } ${
                      viewMode === "os3d" ? classes.terminalButtonSelected : ""
                    }`}
                    onClick={() => {
                      setViewMode("os3d");
                      closeMenu();
                    }}
                  >
                    <span>3D</span>
                  </div>
                </div>
              </div>

              <div className={classes.terminalHeaderMobileMenuRow}>
                <div className={classes.menuItemInt}>
                  <VscEditorLayout
                    className={classes.menuIcon}
                    style={{ fontSize: "16px" }}
                  />
                  Web editor
                </div>
                <div className={classes.terminalHeaderMobileButtons}>
                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton2D
                    } ${
                      viewMode === "editor2d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => {
                      setViewMode("editor2d");
                      closeMenu();
                    }}
                  >
                    <span>2D</span>
                  </div>

                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton3D
                    } ${
                      viewMode === "editor3d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => {
                      setViewMode("editor3d");
                      closeMenu();
                    }}
                  >
                    <span>3D</span>
                  </div>
                </div>
              </div>

              <div className={classes.terminalHeaderMobileMenuRow}>
                <div className={classes.menuItemInt}>
                  <FaCode
                    className={classes.menuIcon}
                    style={{ fontSize: "16px" }}
                  />
                  Code playground
                </div>
                <div className={classes.terminalHeaderMobileButtons}>
                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton2D
                    } ${
                      viewMode === "code2d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => {
                      setViewMode("code2d");
                      closeMenu();
                    }}
                  >
                    <span>2D</span>
                  </div>

                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton3D
                    } ${
                      viewMode === "code3d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => {
                      setViewMode("code3d");
                      closeMenu();
                    }}
                  >
                    <span>3D</span>
                  </div>
                </div>
              </div>

              <div className={classes.terminalHeaderMobileMenuRow}>
                <div className={classes.menuItemInt}>
                  <IoVolumeMedium
                    className={classes.menuIcon}
                    style={{ fontSize: "20px" }}
                  />
                  Audio
                </div>
                <div className={classes.terminalHeaderMobileButtons}>
                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton2D
                    } ${
                      viewMode === "audio2d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => {
                      setViewMode("audio2d");
                      closeMenu();
                    }}
                  >
                    <span>2D</span>
                  </div>

                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton3D
                    } ${
                      viewMode === "audio3d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => {
                      setViewMode("audio3d");
                      closeMenu();
                    }}
                  >
                    <span>3D</span>
                  </div>
                </div>
              </div>

              <div className={classes.terminalHeaderMobileMenuRow}>
                <div className={classes.menuItemInt}>
                  <IoVideocam
                    className={classes.menuIcon}
                    style={{ fontSize: "20px" }}
                  />
                  Video
                </div>
                <div className={classes.terminalHeaderMobileButtons}>
                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton2D
                    } ${
                      viewMode === "video2d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => {
                      setViewMode("video2d");
                      closeMenu();
                    }}
                  >
                    <span>2D</span>
                  </div>

                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton3D
                    } ${
                      viewMode === "video3d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => {
                      setViewMode("video3d");
                      closeMenu();
                    }}
                  >
                    <span>3D</span>
                  </div>
                </div>
              </div>

              <div className={classes.terminalHeaderMobileMenuRow}>
                <div className={classes.menuItemInt}>
                  <MdKeyboardAlt
                    className={classes.menuIcon}
                    style={{ fontSize: "17px" }}
                  />
                  C64
                </div>
                <div className={classes.terminalHeaderMobileButtons}>
                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton2D
                    } ${
                      viewMode === "c642d" ? classes.terminalButtonSelected : ""
                    }`}
                    onClick={() => {
                      setViewMode("c642d");
                      closeMenu();
                    }}
                  >
                    <span>2D</span>
                  </div>

                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton3D
                    } ${
                      viewMode === "c643d" ? classes.terminalButtonSelected : ""
                    }`}
                    onClick={() => {
                      setViewMode("c643d");
                      closeMenu();
                    }}
                  >
                    <span>3D</span>
                  </div>
                </div>
              </div>

              <div className={classes.terminalHeaderMobileMenuRow}>
                <div className={classes.menuItemInt}>
                  <FaCoffee
                    className={classes.menuIcon}
                    style={{ fontSize: "19px" }}
                  />
                  Coffee break
                </div>
                <div className={classes.terminalHeaderMobileButtons}>
                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton2D
                    } ${
                      viewMode === "coinop2d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => {
                      setViewMode("coinop2d");
                      closeMenu();
                    }}
                  >
                    <span>2D</span>
                  </div>

                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton3D
                    } ${
                      viewMode === "coinop3d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => {
                      setViewMode("coinop3d");
                      closeMenu();
                    }}
                  >
                    <span>3D</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={classes.terminalHeaderTop}>
            <div className={classes.menuItem}>
              <div className={classes.menuItemInt}>
                <HiTerminal className={classes.menuIcon} />
                Terminal
              </div>

              <div className={classes.subMenu}>
                <div className={classes.terminalHeaderButton}>
                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton2D
                    } ${
                      viewMode === "terminal2d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => setViewMode("terminal2d")}
                  >
                    <span>2D</span>
                  </div>

                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton3D
                    } ${
                      viewMode === "terminal3d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => setViewMode("terminal3d")}
                  >
                    <span>3D</span>
                  </div>
                </div>
              </div>
            </div>

            <div className={classes.menuItem}>
              <div className={classes.menuItemInt}>
                <MdOutlineDesktopWindows
                  className={classes.menuIcon}
                  style={{ fontSize: "17px" }}
                />
                Os interface
              </div>

              <div className={classes.subMenu}>
                <div className={classes.terminalHeaderButton}>
                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton2D
                    } ${
                      viewMode === "os2d" ? classes.terminalButtonSelected : ""
                    }`}
                    onClick={() => setViewMode("os2d")}
                  >
                    <span>2D</span>
                  </div>

                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton3D
                    } ${
                      viewMode === "os3d" ? classes.terminalButtonSelected : ""
                    }`}
                    onClick={() => setViewMode("os3d")}
                  >
                    <span>3D</span>
                  </div>
                </div>
              </div>
            </div>

            <div className={classes.menuItem}>
              <div className={classes.menuItemInt}>
                <VscEditorLayout
                  className={classes.menuIcon}
                  style={{ fontSize: "17px" }}
                />
                Web editor
              </div>

              <div className={classes.subMenu}>
                <div className={classes.terminalHeaderButton}>
                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton2D
                    } ${
                      viewMode === "editor2d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => setViewMode("editor2d")}
                  >
                    <span>2D</span>
                  </div>

                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton3D
                    } ${
                      viewMode === "editor3d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => setViewMode("editor3d")}
                  >
                    <span>3D</span>
                  </div>
                </div>
              </div>
            </div>

            <div className={classes.menuItem}>
              <div className={classes.menuItemInt}>
                <FaCode
                  className={classes.menuIcon}
                  style={{ fontSize: "17px" }}
                />
                Code playground
              </div>

              <div className={classes.subMenu}>
                <div className={classes.terminalHeaderButton}>
                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton2D
                    } ${
                      viewMode === "code2d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => setViewMode("code2d")}
                  >
                    <span>2D</span>
                  </div>

                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton3D
                    } ${
                      viewMode === "code3d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => setViewMode("code3d")}
                  >
                    <span>3D</span>
                  </div>
                </div>
              </div>
            </div>

            <div className={classes.menuItem}>
              <div className={classes.menuItemInt}>
                <IoVolumeMedium
                  className={classes.menuIcon}
                  style={{ fontSize: "21px" }}
                />
                Audio
              </div>

              <div className={classes.subMenu}>
                <div className={classes.terminalHeaderButton}>
                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton2D
                    } ${
                      viewMode === "audio2d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => setViewMode("audio2d")}
                  >
                    <span>2D</span>
                  </div>

                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton3D
                    } ${
                      viewMode === "audio3d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => setViewMode("audio3d")}
                  >
                    <span>3D</span>
                  </div>
                </div>
              </div>
            </div>

            <div className={classes.menuItem}>
              <div className={classes.menuItemInt}>
                <IoVideocam
                  className={classes.menuIcon}
                  style={{ fontSize: "21px" }}
                />
                Video
              </div>

              <div className={classes.subMenu}>
                <div className={classes.terminalHeaderButton}>
                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton2D
                    } ${
                      viewMode === "video2d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => setViewMode("video2d")}
                  >
                    <span>2D</span>
                  </div>

                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton3D
                    } ${
                      viewMode === "video3d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => setViewMode("video3d")}
                  >
                    <span>3D</span>
                  </div>
                </div>
              </div>
            </div>

            <div className={classes.menuItem}>
              <div className={classes.menuItemInt}>
                <MdKeyboardAlt
                  className={classes.menuIcon}
                  style={{ fontSize: "17px" }}
                />
                C64
              </div>

              <div className={classes.subMenu}>
                <div className={classes.terminalHeaderButton}>
                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton2D
                    } ${
                      viewMode === "c642d" ? classes.terminalButtonSelected : ""
                    }`}
                    onClick={() => setViewMode("c642d")}
                  >
                    <span>2D</span>
                  </div>

                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton3D
                    } ${
                      viewMode === "c643d" ? classes.terminalButtonSelected : ""
                    }`}
                    onClick={() => setViewMode("c643d")}
                  >
                    <span>3D</span>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes.menuItem}>
              <div className={classes.menuItemInt}>
                <FaCoffee
                  className={classes.menuIcon}
                  style={{ fontSize: "19px" }}
                />
                Coffee break
              </div>

              <div className={classes.subMenu}>
                <div className={classes.terminalHeaderButton}>
                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton2D
                    } ${
                      viewMode === "coinop2d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => setViewMode("coinop2d")}
                  >
                    <span>2D</span>
                  </div>

                  <div
                    className={`${classes.terminalButton} ${
                      classes.terminalButton3D
                    } ${
                      viewMode === "coinop3d"
                        ? classes.terminalButtonSelected
                        : ""
                    }`}
                    onClick={() => setViewMode("coinop3d")}
                  >
                    <span>3D</span>
                  </div>
                </div>
              </div>
            </div>

            <div className={classes.menuItem}>
              <div
                className={classes.menuItemInt}
                onClick={() => setTerminal(false)}
              >
                <IoClose
                  className={classes.menuIcon}
                  style={{ fontSize: "20px" }}
                />
                Close
              </div>
            </div>
          </div>

          <Modal
            isOpen={isOpenModal}
            onClose={closeModal}
            title={modalTitle}
            edit={isEditModal}
          >
            <pre>{modalData}</pre>
          </Modal>

          {viewMode === "terminal3d" ? (
            <>
              <iframe
                src="https://monitor-old.davidebalice.dev/?d=2"
                title="monitorOld"
                className={classes.monitorOld}
              />
            </>
          ) : viewMode === "os3d" ? (
            <>
              <iframe
                src="https://monitor.davidebalice.dev/?d=2"
                title="monitor"
                className={classes.monitor}
              />
            </>
          ) : viewMode === "os2d" ? (
            <>
              <iframe
                src="https://os-interface.davidebalice.dev/?d=2"
                title="osInterface"
                className={classes.osInterface}
              />
            </>
          ) : viewMode === "editor3d" ? (
            <>
              <iframe
                src="https://monitor2.davidebalice.dev/?d=2"
                title="monitor2"
                className={classes.monitor}
              />
            </>
          ) : viewMode === "editor2d" ? (
            <>
              <iframe
                src="https://web-editor.davidebalice.dev/?d=2"
                title="webEditor"
                className={classes.osInterface}
              />
            </>
          ) : viewMode === "code3d" ? (
            <>
              <iframe
                src="https://monitor3.davidebalice.dev/?d=2"
                title="monitor3"
                className={classes.monitor}
              />
            </>
          ) : viewMode === "code2d" ? (
            <>
              <iframe
                src="https://code-playground.davidebalice.dev/?d=2"
                title="webEditor"
                className={classes.osInterface}
              />
            </>
          ) : viewMode === "audio3d" ? (
            <>
              <iframe
                src="https://audio.davidebalice.dev/?d=2"
                title="audio"
                className={classes.audio}
              />
            </>
          ) : viewMode === "audio2d" ? (
            <>
              <iframe
                src="https://audio-player.davidebalice.dev/?d=2"
                title="audioPlayer"
                className={classes.audioPlayer}
              />
            </>
          ) : viewMode === "video3d" ? (
            <>
              <iframe
                src="https://video.davidebalice.dev/?d=2"
                title="video"
                className={classes.video}
              />
            </>
          ) : viewMode === "video2d" ? (
            <>
              <iframe
                src="https://video-player.davidebalice.dev/?d=2"
                title="videoPlayer"
                className={classes.videoPlayer}
              />
            </>
          ) : viewMode === "c643d" ? (
            <>
              <iframe
                src="https://c64.davidebalice.dev/?d=2"
                title="audio"
                className={classes.audio}
              />
            </>
          ) : viewMode === "c642d" ? (
            <>
              <iframe
                src="https://c64-prompt.davidebalice.dev/"
                title="audioPlayer"
                className={classes.audioPlayer}
              />
            </>
          ) : viewMode === "coinop3d" ? (
            <>
              <iframe
                src="https://coinop.davidebalice.dev/?d=2"
                title="coinop"
                className={classes.audio}
              />
            </>
          ) : viewMode === "coinop2d" ? (
            <>
              <iframe
                src="https://games.davidebalice.dev/"
                title="games"
                className={classes.audioPlayer}
              />
            </>
          ) : viewMode === "info" ? (
            <>
              <Container className="text-justify privacy-page">
                <Row>
                  <Col style={{ fontSize: "16px" }}>
                    <Spacer height={60} />
                    <b style={{ fontSize: "21px" }}>
                      <FaInfoCircle size="21" /> Info
                    </b>
                    <br />
                    <br />
                    {lang === "en" && (
                      <>
                        In this section of the website, there are{" "}
                        <b>some examples of interfaces</b>.
                        <br />
                        The first one simulates a real <b>terminal</b>, allowing
                        navigation through the server's file system via text
                        commands.
                        <br />
                        The second one recreates the design of an{" "}
                        <b>operating system</b> similar to Windows, with a
                        system of <b>multiple windows</b> that can be moved,
                        resized, or minimized, ideal for having multiple pieces
                        of information open simultaneously.
                        <br />
                        There is also an <b>audio player</b> and a{" "}
                        <b>gaming hub</b>.
                      </>
                    )}
                    {lang === "it" && (
                      <>
                        In questa sezione del sito web sono presenti{" "}
                        <b>alcuni esempi di interfacce</b>.
                        <br />
                        La prima riproduce un vero <b>terminale</b>, che
                        consente di navigare tra il <b>file system</b> del
                        server tramite comandi testuali.
                        <br />
                        La seconda ripropone il design di un{" "}
                        <b>sistema operativo</b> simile a Windows, con un
                        sistema di <b>finestre multiple</b> che possono essere
                        spostate, ridimensionate o ridotte a icona, ideale per
                        avere più informazioni aperte contemporaneamente.
                        <br />
                        E' presente inoltre un <b>audio player</b> ed un{" "}
                        <b>gaming hub</b>.
                      </>
                    )}
                    <br />
                    <br />
                    <br />
                    <img
                      src={github}
                      alt="github logo"
                      style={{ width: "130px" }}
                    />
                    <br />
                    <br />
                    <b>Terminal</b>
                    <br />
                    <a
                      href="https://github.com/davidebalice/react-terminal-emulator"
                      target="_blank"
                      rel="noreferrer"
                    >
                      github.com/davidebalice/react-terminal-emulator
                    </a>
                    <br />
                    <br />
                    <b>Os interface</b>
                    <br />
                    <a
                      href="https://github.com/davidebalice/react-os-interface"
                      target="_blank"
                      rel="noreferrer"
                    >
                      github.com/davidebalice/react-os-interface
                    </a>
                    <br />
                    <br />

                    <b>Audio player</b>
                    <br />
                    <a
                      href=" https://github.com/davidebalice/audio-player"
                      target="_blank"
                      rel="noreferrer"
                    >
                      github.com/davidebalice/audio-player
                    </a>
                    <br />
                    <br />

                    <b>Fs api</b>
                    <br />
                    <a
                      href="https://github.com/davidebalice/node-file-system-api"
                      target="_blank"
                      rel="noreferrer"
                    >
                      github.com/davidebalice/node-file-system-api
                    </a>
                  </Col>
                </Row>
              </Container>
            </>
          ) : (
            <>
              <Terminal
                history={history}
                setHistory={setHistory}
                openTerminal={openTerminal}
                setOpenTerminal={setOpenTerminal}
                openLogin={openLogin}
                setOpenLogin={setOpenLogin}
                username={username}
                setUsername={setUsername}
                ref={setTerminalRef}
                commands={commands}
                commandsHistory={commandsHistory}
                setCommandsHistory={setCommandsHistory}
              />
            </>
          )}
        </div>
      )}
    </>
  );
};

export default TerminalContainer;
